import { NavSettingsService, InfUserSettingsAccess } from '@common/services/settingsservice';
import { CompatibilityService } from '@services/compatibilityservice';
import { fn } from '@common/utils';
import { NavUrlService } from '@common/services/navurlservice';
import { NavClientService, NavPageItem, NavPageItems, NavPropertyItem, IPageQueryConstraint, Observable } from '../../navdata/navdata';
import * as kutils from '../../navkendo';
import GetCommandItem = kutils.GetCommandItem;
import { FDDI_DMS_Purchase_Document, FDRW_Anordnungsblatt } from '@common/rwf/rwf.const';
import { RWF3BaseService } from '../../editform/rwf3baseservice';
import {
  IFDRW_Kontierungsvorschlag, IIAX_DMSPurch_DocumentLine, IFDDI_DMS_Purchase_Document,
  IFDRW_RecentlyPostedInvoice_List,
  FDRW_RecentAO_List,
  IFDRW_Kam_Kontierungsvorschlag,
  IFDRW_RecentAO_List,
  IFDRW_Anordnungsblatt,
  IsRechnungMitBestellbezug
} from '@common/rwf';
import { INavItemsGridOptions } from '../../navkendo';
import { isNumber } from 'util';
import { SessionEvents } from '@common/rwf/rwfedit.common';

const MAX_READ = 250;
const FDRW_Kontierungsvorschlag = "FDRW_Kontierungsvorschlag";
const FDRW_RecentlyPostedInvoice_List = "FDRW_RecentlyPostedInvoice_List";
const FDRW_RecentAO_List = "FDRW_RecentAO_List";
const FDRW_Kam_Kontierungsvorschlag = "FDRW_Kam_Kontierungsvorschlag";

type TKontierungsVorschlagPage = "FDRW_Kontierungsvorschlag" | "FDRW_RecentlyPostedInvoice_List" | "FDRW_RecentAO_List" | "FDRW_Kam_Kontierungsvorschlag";
const DockTitle: { [name in TKontierungsVorschlagPage]: string } = {
  FDRW_Kontierungsvorschlag: "Kontierungsvorschlag",
  FDRW_RecentlyPostedInvoice_List: "Zuletzt gebucht",
  FDRW_Kam_Kontierungsvorschlag: "Kontierungsvorschlag",
  FDRW_RecentAO_List: "Zuletzt Angeordnet"
};
type TBaseKontierungsVorschlag = NavPageItems<IFDRW_Kontierungsvorschlag> | NavPageItems<IFDRW_RecentlyPostedInvoice_List> | NavPageItems<FDRW_RecentAO_List> | NavPageItems<IFDRW_Kam_Kontierungsvorschlag>;
type TBaseKontierungsVorschlagItem = NavPropertyItem<IFDRW_Kontierungsvorschlag> | NavPropertyItem<IFDRW_RecentlyPostedInvoice_List> | NavPropertyItem<FDRW_RecentAO_List> | NavPropertyItem<IFDRW_Kam_Kontierungsvorschlag>;

type TSourcePage = "FDDI_DMS_Purchase_Document" | "FDRW_Anordnungsblatt";
type TSourceItem = NavPageItem<IFDDI_DMS_Purchase_Document> | NavPageItems<IFDRW_Anordnungsblatt>;
type TSourceModel = IFDDI_DMS_Purchase_Document | IFDRW_Anordnungsblatt;
type TVorschlagType = 'vorschlag' | 'zuletztgebucht';
interface IKontierungsvorschlag {
  MainItem: TSourceItem;
  SourcePage: TSourcePage;
  Type: TVorschlagType;
  ShowDock: boolean;
  Suggestions: TBaseKontierungsVorschlag;
  /** Loaded EInvoiceTemplates for Current Context */
  EInvoiceGridOptions: kutils.INavItemsGridOptions;
  LoadError: string;
  DockTitle: string;
}

/** Display eInvoice Templates to be Selected by user to Apply to Current Form */
export class CtrlKontierungsVorschlag extends Observable implements Partial<IKontierungsvorschlag> {
  /** Kontierungsvorschlag as Directive */
  static Directive = ["$parse", function ($parse: ng.IParseService): ng.IDirective {
    return {
      controller: CtrlKontierungsVorschlag,
      controllerAs: "vm",
      template: require('./kontierungsvorschlag.ctrl.html'),
      scope: {
        service: "=service",
        reference: "=reference",
        type: "=type" // --> TVorschlagType
      },

      link: ($scope: CtrlKontierungsVorschlagScope, element, attributes, controller: CtrlKontierungsVorschlag | {}) => {
        if (attributes.reference) {
          const p = $parse(attributes.reference);
          p.assign($scope.$parent, controller);
          $scope.$on("$destroy", () => p.assign($scope.$parent, undefined));
        }
      }
    };
  }];
  static $inject = ["$scope", "CompatibilityService", "NavClient", "NavUrlService", "NavSettings"];
  constructor(
    $scope: CtrlKontierungsVorschlagScope,
    private readonly $c: CompatibilityService,
    private readonly NavClientService: NavClientService,
    private NavUrlService: NavUrlService,
    private NavSettingsService: NavSettingsService
  ) {
    super();
    const service = $scope.service;
    const session = service && service.Session;

    if (!session) {
      console.error("Missing Session");
    }

    const bootstrapParameters = $c.resolve("Rwf")("RwfBootstrap").EnsureResolved();
    const IsEInvoiceManagerActive = bootstrapParameters.RwfSetup.IsEInvoiceManagerActive && !bootstrapParameters.RwfSettings.User.IsStandalone;
    if (!IsEInvoiceManagerActive) {
      const r: IKontierungsvorschlag = <any><Partial<IKontierungsvorschlag>>{
        EInvoiceGridOptions: undefined,
        ShowDock: false,
      };
      $.extend(this, r);
      return;
    }

    const operationAllowed = () => {
      if (this.IsInOperation || !session || session.IsInOperation) {
        return false;
      }

      if (session.NoEdit === true) {
        return false;
      }

      return true;
    };

    const reload = () => {
      const item = session.DisplayItem?.Anchor.Source as TSourceItem;
      this.Reload(item, $scope.type, operationAllowed);

      //TODO: ccc
      // Im Kameralen fall ändern sich die Vorschläge mit der Adresse!
      switch (item?.PageName) {
        case FDRW_Anordnungsblatt:
          const aoItems = item as NavPageItems<IFDRW_Anordnungsblatt>;
          let currAddr = aoItems.SelectedItems[0] && aoItems.SelectedItems[0].Model.Adressnr;
          const checkAoSelectionChanged = () => {
            this.trigger("checkAoSelectionChanged");
            const item = aoItems.SelectedItems[0];
            const doRefresh = () => {
              var checkNo = item && item.Model.Adressnr;
              if (currAddr !== checkNo) {
                currAddr = checkNo;
                reload();
              }
            };
            if (item) {
              this.bind("checkAoSelectionChanged", item.RegisterPropertyChanged("Adressnr", doRefresh));
            }
          };
          this.bind("Reload", aoItems.RegisterSelectionChanged(checkAoSelectionChanged));
          checkAoSelectionChanged();
          break;
        case FDDI_DMS_Purchase_Document:
          const purchDoc = item as NavPageItem<IFDDI_DMS_Purchase_Document>;
          const Buy_from_Vendor_No = "Buy_from_Vendor_No"
          let currBuy_from_Vendor_No;
          const vendorNoChanged = () => {
            let check = purchDoc.GetValue(Buy_from_Vendor_No);
            if (check !== currBuy_from_Vendor_No) {
              currBuy_from_Vendor_No = check;
              reload();
            }
          };
          this.one("Reload", purchDoc.RegisterPropertyChanged(Buy_from_Vendor_No, vendorNoChanged));
          break;
      }
    };

    session.bind(SessionEvents.displaypagechange, reload);
    reload();
  }

  private operationAllowed = (item: TBaseKontierungsVorschlagItem) => !!item;

  public Reload(mainItem: TSourceItem, type: TVorschlagType, operationAllowed: (item: TBaseKontierungsVorschlagItem) => boolean) {
    this.trigger("Reload");
    const $c = this.$c;
    const me: Partial<IKontierungsvorschlag> = this;
    const rValue: IKontierungsvorschlag = <IKontierungsvorschlag>{
      DockTitle: 'Kontierungsvorschlag',
      Type: type,
      LoadError: '',
      SourcePage: mainItem && mainItem.PageName,
      MainItem: mainItem,
      EInvoiceGridOptions: null,
      ShowDock: null,
      Suggestions: null
    } as IKontierungsvorschlag;
    if ([FDDI_DMS_Purchase_Document, FDRW_Anordnungsblatt].indexOf(mainItem && mainItem.PageName) < 0) {
      rValue.ShowDock = false;
      result = $c.when(rValue);
    } else {
      const sourcePageName = mainItem.PageName as TSourcePage;

      const page = GetVorschlagPage(type, sourcePageName);
      this.Loading = true;
      delete me.EInvoiceGridOptions; // Force ReCreate Of Grid
      var result = $c.resolve("Rwf")("RwfBootstrap").Resolve.
        then(rwf => {

          if (rwf.RwfSetup.IsEInvoiceManagerActive !== true ||
            rwf.RwfSettings.CheckPages[page] === false) {
            rValue.EInvoiceGridOptions = null;
            rValue.ShowDock = false;
            return rValue;
          }

          switch (sourcePageName) {
            case FDDI_DMS_Purchase_Document:
              const purchItem = mainItem as NavPageItem<IFDDI_DMS_Purchase_Document>;
              if (purchItem.Model.Document_Type != 2 || IsRechnungMitBestellbezug(purchItem)) {
                rValue.ShowDock = false;
              }
              break;
            case FDRW_Anordnungsblatt:
              break;
            default:
              rValue.ShowDock = false;
          }
          if (rValue.ShowDock === false) {
            return rValue;
          }

          //const source = mainItem.Model as TSourceModel;
          const constraints: IPageQueryConstraint<any>[] = [];
          let getRecId: PromiseLike<string>
          if (sourcePageName == FDDI_DMS_Purchase_Document) {
            const purchItem = mainItem as NavPageItem<IFDDI_DMS_Purchase_Document>;
            getRecId = this.NavClientService.GetRecIdFromKey(mainItem.ClientInfo.Url, mainItem.PageName, purchItem.Key)
            const sourceDoc = purchItem.Model;
            (constraints as IPageQueryConstraint<IFDRW_Kontierungsvorschlag | IFDRW_RecentlyPostedInvoice_List>[]).push({
              FieldName: "Vendor_No",
              Value: sourceDoc.Buy_from_Vendor_No
            });

            if (page == FDRW_Kontierungsvorschlag && sourceDoc.OrderNo) {
              // WI-135786 : Bei bestehendem Bestellbezug "Informationsquelle Bestellung" ausblenden
              constraints.push({
                FieldName: "Sourcetype", Value: "<> 1"
              });
            }
          } else if (sourcePageName == FDRW_Anordnungsblatt) {
            const sourceAO = (mainItem as NavPageItems).Items[0].Model as any as IFDRW_Anordnungsblatt;
            (constraints as IPageQueryConstraint<IFDRW_Kam_Kontierungsvorschlag | IFDRW_RecentAO_List>[]).push({
              FieldName: "Address_No",
              Value: sourceAO.Adressnr
            });
          } else {
            fn.never(sourcePageName, "Page not expected:" + sourcePageName);
          }
          return $c.when(getRecId).then(resolvedRecId => {
            if (resolvedRecId) {
              constraints.push({
                FieldName: <keyof (IFDRW_Kontierungsvorschlag | IFDRW_Kam_Kontierungsvorschlag | IFDRW_RecentlyPostedInvoice_List)>"Acc_Description",
                Value: "*|*«" + resolvedRecId + "»"
              });
            }
          }).then(() => this.NavClientService.LoadPageItems({
            PageName: page,
            Constraints: constraints,
            PageCount: MAX_READ
          }, this.NavUrlService).then(result => {

            // Set Up Grid Options and Per user persistence
            const settings = this.NavSettingsService.CreateUserSettings(["KWF", "Kontierungsvorschlag" + (rValue.SourcePage == "FDDI_DMS_Purchase_Document" ? "" : "_kam") + "_" + (type)]);
            this.one("Reload", () => settings.Save());

            return settings.ForceLoaded().then(fn.identity, fn.noop).then(lSettings => {
              rValue.ShowDock = result.Count > 0;
              rValue.Suggestions = result as NavPageItems;
              result.Anchor.Readonly.SetForceAll(true);
              rValue.DockTitle = (DockTitle[page] || rValue.DockTitle) + (result.Count > 0 ? " (" + (result.AllRead ? "" : ">") + result.Count + ")" : "");
              rValue.EInvoiceGridOptions = result.Count > 0 && this.createGridOptions(rValue, <any>result, lSettings, settings);

              return rValue;
            });
          }));
        });
    }

    result.then(fn.noop, err => {
      rValue.ShowDock = true;
      rValue.LoadError = fn.resolveToError(err);
    });
    this.IsInOperation = true;
    $c.finally(result, () => {
      this.IsInOperation = false;
      this.Initialized = true;
      if (typeof rValue.ShowDock !== "boolean") {
        rValue.ShowDock = true;
      }

      if (this.CurrentRequest === result) {
        this.CurrentVorschlag = rValue;
        this.Loading = false;
        $.extend(this, rValue);
      }
    });

    this.operationAllowed = operationAllowed || (item => true);
    return result = this.CurrentRequest;
  }

  /** Wait for Marker on UI */
  public Initialized: boolean;
  public Loading: boolean;

  public CurrentRequest: PromiseLike<IKontierungsvorschlag>;
  public CurrentVorschlag: IKontierungsvorschlag;
  // Dispatched from Current Vorschlag ...
  public ShowDock: boolean;

  public IsInOperation = false;

  private doApplyTemplate(config: IKontierungsvorschlag, vorschlag: TBaseKontierungsVorschlagItem, applyLines?: boolean) {
    if (!this.operationAllowed(vorschlag))
      return this.$c.reject('Die Aktion ist unzulässig');

    const mainItem = config.MainItem;
    return mainItem.Anchor.EnqueueOperation(() => {
      var curItem: NavPropertyItem;
      switch (mainItem.PageName as TSourcePage) {
        case FDDI_DMS_Purchase_Document:
          curItem = mainItem as NavPageItem<IFDDI_DMS_Purchase_Document>;
          const docModel = vorschlag.Model as IFDRW_Kontierungsvorschlag | IFDRW_RecentlyPostedInvoice_List;
          var methodName = applyLines ? "ApplyEInvoiceTemplate" : "ApplyEInvoiceHeaderTemplate";
          const lineItem: NavPropertyItem<IIAX_DMSPurch_DocumentLine> = mainItem && mainItem.ClientInfo.MasterLineProperty &&
            (mainItem as NavPageItem).GetLineData(mainItem.ClientInfo.MasterLineProperty).SelectedItems[0];
          var params: any = {
            purchHeader: curItem.Key,
            Document_No: lineItem.Model.Document_No,
            Line_No: lineItem.Model.Line_No,
            templateID: IsRecentlyPosted(docModel) ? docModel.Num : docModel.No
          };
          break;
        case FDRW_Anordnungsblatt:
          curItem = (mainItem as NavPageItems<IFDRW_Anordnungsblatt>).Container.SelectedItems[0];
          const aoModel = vorschlag.Model as IFDRW_RecentAO_List | IFDRW_Kam_Kontierungsvorschlag;
          methodName = "ApplyEInvoiceLineHistInfoToEZH";
          params = {
            erfassungszeileHUEL: curItem.Key,
            templateID: aoModel.No
          };
          break;
        default:
          return this.$c.reject("Unexpected Item!");
      }

      var result = mainItem.Anchor.ExecuteMethod({
        MethodName: methodName,
        Parameters: params
      }).then(fn.noop, err => {
        this.$c.resolve("DialogService").ShowError(err);
        fn.error.UICancel(err);
      });

      this.IsInOperation = true;
      const resetInOperation = () => this.IsInOperation = false;
      result.then(resetInOperation, resetInOperation);
      return result;
    });
  };

  private createGridOptions(vorschlag: IKontierungsvorschlag, items: TBaseKontierungsVorschlag, lSettings: any, settings: InfUserSettingsAccess) {
    const isKameral = vorschlag.SourcePage === FDRW_Anordnungsblatt;
    return <INavItemsGridOptions>{
      baseOptions: {
        filterable: true,
        pageable: {
          pageSize: 10,
        },
        columns: [{
          title: 'Aktion',
          filterable: false,
          minResizableWidth: isKameral ? 50 : 80,
          width: isKameral ? "55px" : "85px",
          command:
            isKameral ? [
              GetCommandItem({
                name: "KAMApplyEInvoiceTemplateItem",
                title: "Kontierung aktualisieren",
                iconClass: "idms_Image idms_Image_Previous idms_HoverImage",
                action: (item) => {
                  const invItem = items.GetItems(item)[0];
                  this.doApplyTemplate(vorschlag, invItem, true);
                }
              })
            ] :
              [GetCommandItem(
                {
                  name: "ApplyEInvoiceTemplateItem",
                  title: "Zeilendaten aktualisieren",
                  iconClass: "idms_Image idms_Image_Previous idms_HoverImage",
                  action: (item) => {
                    const invItem = items.GetItems(item)[0];
                    this.doApplyTemplate(vorschlag, invItem, true);
                  }
                }), GetCommandItem(
                  {
                    name: "ApplyEInvoiceHeaderTemplateItem",
                    title: "Kopfdaten aktualisieren",
                    iconClass: "idms_Image idms_Image_MoveUp idms_HoverImage",
                    action: (item) => {
                      const invItem = items.GetItems(item)[0];
                      this.doApplyTemplate(vorschlag, invItem, false);
                    }
                  }
                )]
        }
        ],
        editable: false,
      },
      EditContext: {
        AddSetting: (name, s) => {
          if (lSettings && lSettings[name])
            s.apply(lSettings[name]);
          if (settings) {
            return settings.Add(name, s);
          }
        },
        AddDispose: (s) => this.one("Reload", s),
        GetAttachedParent: fn.nullOp
      },
      Source: items
    };
  }
}

function GetVorschlagPage(this: void, type: TVorschlagType, sourcePageName: TSourcePage): TKontierungsVorschlagPage {
  if (sourcePageName && type) {
    switch (type) {
      case "zuletztgebucht":
        return sourcePageName == FDDI_DMS_Purchase_Document ? FDRW_RecentlyPostedInvoice_List : FDRW_RecentAO_List;
      default:
        return sourcePageName == FDDI_DMS_Purchase_Document ? FDRW_Kontierungsvorschlag : FDRW_Kam_Kontierungsvorschlag;
    }
  }
}
/** FDRW_Kontierungsvorschlag.No and FDRW_RecentlyPostedInvoice_List.Num used to be identically named ... would be nice again */
function IsRecentlyPosted(item: IFDRW_RecentlyPostedInvoice_List | IFDRW_Kontierungsvorschlag): item is IFDRW_RecentlyPostedInvoice_List {
  var check: Omit<IFDRW_RecentlyPostedInvoice_List & IFDRW_Kontierungsvorschlag, keyof IFDRW_RecentlyPostedInvoice_List> = <any>item;
  return !isNumber(check.No);
}

interface CtrlKontierungsVorschlagScope extends ng.IScope {
  service: RWF3BaseService;
  type: TVorschlagType;
}
